// import CommentListing from "components/CommentListing/CommentListing";
import React, { FC, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import { Helmet } from "react-helmet";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { checkLogin, logOut, updateMyAvatar } from "functions/redux/user/action";
import Button from "shared/Button/Button";
import { useHistory } from "react-router";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import NcModal from "shared/NcModal/NcModal";
import { showAlert } from "functions/redux/general/action";
import '../../styles/myStyle.css';
import { authJsonPost } from "functions/BaseAxios";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { getNotification, getNotificationAll, getShowItemList, updateShowItemList } from "functions/redux/notification/action";
export interface AuthorPageProps {
    className?: string;
}

const PageNotification: FC<AuthorPageProps> = ({ className = "" }) => {
    const dispatch = useDispatch();
    const { user, general, notificationReducer } = useSelector((state: RootStore) => state);

    const history = useHistory();
    const [loading, setLoading] = useState("");
    const [mobileEditProfile, setMobileEditProfile] = useState(false);

    const { t } = useTranslation();
    const [showConfirmation, setShowConfirmation] = React.useState(false);
    // const [loading, setLoading] = useState(true);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [page, setpage] = useState(1)


    React.useEffect(() => {
        if (user.credential == null) {
            dispatch(checkLogin());


        }
        dispatch(getNotificationAll())


    }, [user])


    const tabsListprofile = ["General"];
    if (user.credential.isGuide === '1') {
        tabsListprofile.push("Guide");
    }



    const logout = async () => {
        await dispatch(logOut());
        history.replace('/')

    }

    // if (notificationReducer.notificationListAll) {
    //     setLoadingNotif(false);
    // }

    const loadMore = async () => {
        setpage(page + 1)
        setLoadingBtn(true);
        updateShowItemList(getShowItemList() + 1);
        await dispatch(getNotificationAll(getShowItemList(), notificationReducer.notificationListAll));

        setLoadingBtn(false);
    }


    const updateAvatar = async (e: any) => {
        setLoading("avatar");
        await dispatch(await updateMyAvatar(e.target.files[0], user.credential?.profile?.id));
        setLoading("");
    }

    const addProduct = () => {
        const select = document.getElementsByClassName('tabProduk')[0].getAttribute('aria-selected');
        if (select === 'true') {
            window.location.href = "/open-trip-add";
        } else {
            window.location.href = "/private-trip-add";
        }

    }
    const style = () => {
        document.querySelector('.PhoneInput')?.querySelector('.PhoneInputInput')?.classList.add("border-0");
    }
    const hoverAvatar = () => {
    }
    const renderSidebar = () => {
        return (
            <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                <div className="relative overflow-hidden" >
                    <Avatar
                        imgUrl={user.credential?.profile?.avatar}
                        sizeClass="w-28 h-28"
                    />

                    {loading === "avatar" &&
                        <div className="absolute items-center justify-center flex  w-28 h-28 bg-white bg-opacity-60">
                            <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            />
                        </div>}
                    <input
                        type="file"
                        className="absolute inset-0  opacity-0 cursor-pointer"
                        onChange={(e) => updateAvatar(e)}
                    />
                </div>


                <div className="space-y-3 text-center flex flex-col items-center">
                    <div className="flex flex-row">
                        <h2 className="text-3xl font-semibold">{user.credential?.profile?.displayName}</h2>
                        {parseInt(user.credential?.isGuide) === 1 && (
                            <span className={` bg-teal-500 rounded-full text-white text-xs flex items-center justify-center   w-4 h-4 `} >
                                <i className="las la-check"></i>
                            </span>)}

                    </div>
                    {/* <StartRating className="!text-base" /> */}
                </div>

                <p className="text-neutral-500 dark:text-neutral-400">
                    {user.credential?.profile?.aboutMe ?? "Write something about you"}

                </p>

                <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

                <div className="space-y-4">
                    {user.credential?.profile?.homeBase &&
                        <div className="flex items-center space-x-4">
                            <div style={{ width: 24 }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-neutral-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                    />
                                </svg>
                            </div>
                            <span className="text-neutral-6000 dark:text-neutral-300">
                                {user.credential?.profile?.homeBase}
                            </span>
                        </div>}
                    {user.credential?.profile?.speaking && (
                        <div className="flex items-center space-x-4">
                            <div style={{ width: 24 }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-neutral-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={1.5}
                                        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                    />
                                </svg>
                            </div>
                            <span className="text-neutral-6000 dark:text-neutral-300" style={{ textAlign: 'left' }}>
                                {user.credential?.profile?.speaking}
                            </span>
                        </div>)}

                    <button onClick={() => setMobileEditProfile(!mobileEditProfile)} className="flex block md:hidden items-center space-x-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-neutral-400"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        <span className="text-neutral-6000 dark:text-neutral-300">
                            Edit Profile
                        </span>
                    </button>

                    <Button className="md:w-min w-full  text-red-800 bg-red-100" onClick={() => setShowConfirmation(true)}>{t('logout')}</Button>
                </div>
            </div >
        );
    };

    const buttonLocation = async (type: any, identifier: any, notif: any) => {


        if (notif.status == 0) {
            let result = await authJsonPost({ id: notif.id }, 'auth/notification/update-read');

            dispatch(getNotification());
        }

        if (type == 'product') {
            if (notif.title == 'Question Product') {
                history.push(`/profile?q=4`)
            } else {
                history.replace(`/detail?q=${notif.slugUrl}&t=${identifier}`)
            }
        } else if (type.includes('your_booked') || type.includes('new_booking') || type.includes('booking_accepted')) {
            history.push(`booking-detail?id=${identifier}`)
        } else if (type == 'guide_approved') {
            history.push(`/profile`)

        }
    }


    const renderSection2 = () => {

        return (
            <div className="listingSection__wrap">
                <div className="hidden md:block">
                    <h2 className="text-2xl font-semibold">Notification</h2>
                    <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    </span>
                </div>
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="block bg-white">

                    {notificationReducer.notificationListAll ? notificationReducer.notificationListAll.length > 0 ? notificationReducer.notificationListAll.map((val: any, key: any) => {
                        let date = new Date();
                        let offset = date.getTimezoneOffset();
                        let dateAnswer = moment(Date.parse(val.createdAt)).add((offset * (-1)), 'm').toNow();
                        return (
                            <div key={val.id} className="mb-2">
                                <button key={val.id}
                                    className={`text-gray-900 marker:group flex rounded-md text-left  w-full px-2 py-2 text-sm hover:bg-primary-50 hover:text-white ${val.status == 0 ? 'bg-neutral-100' : ''}`}
                                    onClick={() => {
                                        buttonLocation(val.slug, val.identifier, val)
                                    }}
                                >
                                    <div className="w-full">
                                        <div className="flex justify-between">
                                            <label style={{ fontWeight: 'bold' }}>{val.title}</label>
                                            <label style={{ fontSize: '0.9em' }}>{dateAnswer} ago</label>
                                        </div>
                                        <p>{val.text}</p>
                                    </div>
                                </button>
                            </div>
                        )
                    }) : (
                        <div className="flex justify-center mb-10">
                            <p>No Notification</p>
                        </div>
                    ) : (
                        <div className="flex justify-center mb-10">
                            <Loader
                                type="Circles"
                                color="#D24D29"
                                height={100}
                                width={100}
                            />
                        </div>
                    )}
                    <ButtonPrimary className="w-full" disabled={loadingBtn} onClick={() => {
                        // setpage(page+1)
                        loadMore()
                    }}>
                        {loadingBtn && (
                            <Loader
                                type="Circles"
                                color="white"
                                height={20}
                                width={20}
                            />
                        )}
                        {!loadingBtn ? <span className="pl-2">Load More</span> : <span className="pl-2">Waiting</span>}
                    </ButtonPrimary>
                </div>


            </div>
        );
    };







    return (
        <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
            <NcModal
                isOpenProp={showConfirmation}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => {
                    return (
                        <div className="max-w-md">
                            <p className="text-center font-regular ">
                                {t('logout_confirm')}
                            </p>
                            <div className="flex justify-center space-x-5 mt-8">
                                <ButtonSecondary onClick={() => setShowConfirmation(false)} >{t('no')}</ButtonSecondary>
                                <ButtonPrimary onClick={() => {
                                    setShowConfirmation(false);
                                    logout();
                                }}
                                >{t('yes')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    )
                }}
                hideCloseBtn={true}
                // contentExtraClass="w-1/4"
                modalTitle={t('logout')}
            />
            <Helmet>
                <title>{user.credential?.profile?.displayName}</title>
            </Helmet>
            <main className="container md:mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="hidden md:block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
                </div>
                <div className="w-full lg:w-3/5 xl:w-2/3 md:space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                    {renderSection2()}
                </div>

            </main>
            <NcModal
                isOpenProp={general.alert.show}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => { return general.alert.content; }}
                onCloseModal={() => {
                    dispatch(showAlert("", "", false))
                }}
                modalTitle={general.alert.title}
            />
            <ToastContainer position="bottom-right" />
        </div>
    );
};

export default PageNotification;
